/**
 * CSV текущей вкладки отчётов (Excel-friendly BOM).
 */

export function csvEscape(value) {
  if (value == null) return '';
  const s = String(value);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function toCsv(headers, rows) {
  const head = (headers || []).map(csvEscape).join(',');
  const body = (rows || []).map((row) => (row || []).map(csvEscape).join(','));
  return `\uFEFF${[head].concat(body).join('\r\n')}`;
}

export function reportCsvFilename(tabLabel, from, to) {
  const tab = String(tabLabel || 'отчёт').replace(/[\\/:*?"<>|]+/g, '_');
  return `Отчёт_${tab}_${from || ''}_${to || ''}.csv`;
}

export function downloadCsv(filename, csvText) {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;
  const blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
